export const getPagination = ({ pagination }) => pagination;

export const extratores_empty = () => ({
  acao_orcamentaria: "",
  area_atuacao: "",
  categorias_do_programa: "",
  codigo_programa: "",
  criterios: "",
  data_disponibilizacao: "",
  data_fim_beneficiario_especifico: "",
  data_inicio_beneficiario_especifico: "",
  descricao: "",
  estados_habilitados: "",
  exige_aceite_licitacao: "",
  nome_programa: "",
  observacao: "",
  orgao: "",
  orgao_executor: "",
  orgao_vinculado: "",
  programa_atende_a: "",
  qualificacao_da_proposta: "",
  subtipo_instrumento: "",
  tipo_instrumento: "",
  created_at: "",
  updated_at: "",
  orgao_concedente: ""
});
